const CHARSET = "charset=utf-8";
const JS_CONTENTTYPE = "text/javascript";
const JSON_CONTENTTYPE = "application/json";
const TEXT_CONTENTTYPE = "text/plain";

const FETCHOPTIONS = {
  credentials: "same-origin",
  headers: {},
  mode: "cors",
  redirect: "error",
  referrerPolicy: "no-referrer",
  signal: null
};

const PROGRESSEVENT_TYPES = {
  ABORT: "abort",
  ERROR: "error",
  LOAD: "load",
  LOADSTART: "loadstart",
  PROGRESS: "progress",
  TIMEOUT: "timeout"
};

const RESULTEVENT_TYPES = {
  AUTOCOMPLETE: "autocomplete",
  GOOGLEPLACE: "googleplace",
  SEARCH: "search"
};

const URLS = {
  autocomplete: "/api/autocomplete",
  baseUrl: location.origin, // "https://www.yourgolftravel.com",
  googlePlace: "/api/google_places",
  health: "/api/health",
  search: "/api/search"
};

export {
  CHARSET,
  FETCHOPTIONS,
  JS_CONTENTTYPE,
  JSON_CONTENTTYPE,
  PROGRESSEVENT_TYPES,
  RESULTEVENT_TYPES,
  TEXT_CONTENTTYPE,
  URLS
};



// WEBPACK FOOTER //
// ./scripts/api/constants.js